import { useEffect, useState, useRef } from "react"
import { SelectInput, TextInput } from "../../../components/Inputs"
import { BoxAlert } from "../../../components/Alerts"

const FormBeforeValidation = ({ data: { appointment, validateDocument, documentValidation, updatePatient, openLogin, resetDocument } }) => {
  const documentTypes = [
    { value: "", label: "Seleccionar" },
    { value: "DNI", label: "DNI" },
    { value: "PAS", label: "Pasaporte" },
    { value: "CI", label: "Cédula" },
  ]

  const { exist, searched, error } = documentValidation
  const [errors, setErrors] = useState({ idType: "", idNumber: "" })

  const onSubmit = () => {
    if (appointment?.patient?.idType && appointment?.patient?.idNumber) {
      validateDocument({
        idType: appointment?.patient?.idType,
        idNumber: appointment?.patient?.idNumber,
      })
    }

    setErrors({
      idType: appointment?.patient?.idType ? "" : "Seleccioná un tipo de documento",
      idNumber: appointment?.patient?.idNumber ? "" : "Completá un número de documento",
    })
  }

  const handleIdType = (value) => updatePatient({ idType: value })
  const handleIdNumber = (value) => {
    // Solo permitimos números y hasta 10 caracteres
    const numericValue = value.replace(/\D/g, "").slice(0, 10)
    updatePatient({ idNumber: numericValue })
  }

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-6 mt-6'>
      <SelectInput data={{
        name: "idType",
        value: appointment?.patient?.idType ?? "",
        onChange: (e) => handleIdType(e.target.value),
        customStyle: searched ? "bg-neutral-100 rounded-lg p-3 outline-none -mb-1" : "",
        label: "Tipo de documento",
        disabled: searched,
        errorText: errors.idType,
        options: documentTypes
      }} />

      <TextInput data={{
        type: "text",
        disabled: searched,
        name: "idNumber",
        value: appointment?.patient?.idNumber ?? "",
        onChange: (e) => handleIdNumber(e.target.value),
        placeholder: "Ej: 40328218",
        customStyle: searched ? "bg-neutral-100 rounded-lg p-3 outline-none -mb-1" : "",
        label: "Número de documento",
        errorText: errors.idNumber
      }} />

      {!searched && <p></p>}

      {searched && exist && (
        <BoxAlert data={{
          type: "warning",
          description: `${error} ${error.includes('cuenta activa') ? "iniciá sesión" : ""}`,
          extraContainerStyles: "sm:col-span-2 -mt-6 mb-2"
        }} />
      )}

      {searched && exist && (
        <>
          <button
            type="button"
            onClick={resetDocument}
            className='w-full text-cyan border-cyan border py-4 px-6 400:px-12 rounded-lg flex-1 -mt-4'
          >
            Cambiar documento
          </button>
          <button
            type="button"
            onClick={openLogin}
            className='w-full text-white bg-cyan py-4 px-6 400:px-12 rounded-lg flex-1 -mt-4'
          >
            Iniciar sesión
          </button>
        </>
      )}

      {!searched && (
        <button
          type="button"
          onClick={onSubmit}
          className='w-full text-white bg-cyan shadow-6 py-4 px-6 400:px-12 rounded-lg flex-1 -mt-4'
        >
          Validar documento
        </button>
      )}
    </div>
  )
}

export default FormBeforeValidation
